import { apiService } from 'services'

import {
  BabyResponse,
  NotificationResponse,
  IBaby,
  IBabySettings,
  IBabyNotification,
  BabyLastEventsResponse,
} from 'types'

const URL = '/babies'

const getBabies = async () => apiService.get<BabyResponse>(URL)

const createBaby = async (data: IBabySettings) => apiService.post(URL, data)

const editBaby = async (babyId: number, data: Pick<IBaby, 'name' | 'birthDate' | 'gender'>) =>
  apiService.put(`${URL}/${babyId}`, data)

const deleteBaby = async (babyId: number) => apiService.delete(`${URL}/${babyId}`)

const getLastEvents = async (babyId: number) =>
  apiService.get<BabyLastEventsResponse>(`${URL}/${babyId}/events/last`)

const getBabyNotifications = async (babyId: number) =>
  apiService.get<NotificationResponse>(`${URL}/${babyId}/notifications`)

const editBabyNotification = async (
  babyId: number,
  notificationId: number,
  data: IBabyNotification,
) => apiService.put(`${URL}/${babyId}/notifications/${notificationId}`, data)

export const BabySettingsApi = {
  getBabies,
  createBaby,
  editBaby,
  deleteBaby,
  getLastEvents,
  getBabyNotifications,
  editBabyNotification,
}
